import request from '@/axios'

// V-02-外访跟进记录
export function visitRecord(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/visitRecord',
    method: 'post',
    data
  })
}
// V-06-外访标签
export function egressVisitLabel(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/egressVisitLabel',
    method: 'post',
    data
  })
}
// V-03-添加外访跟进记录
export function addVisitRecord(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/addVisitRecord',
    method: 'post',
    data
  })
}
// V-05-去访用户列表
export function getUserList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/getUserList',
    method: 'post',
    data
  })
}
export function distributeVisit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/distributeVisit',
    method: 'post',
    data
  })
}
export function getStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/getStaffList',
    method: 'post',
    data
  })
}
export function handOver(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/egress_visit/handOver',
    method: 'post',
    data
  })
}
